// Loading skeleton for the contact edit page (GRAIN-1917). Keep in sync with
// Components::Skeletons::ContactEdit so React hydrates the server-rendered
// skeleton without restarting the shimmer. Matches EditContact's layout: a
// breadcrumb-only header (no status badge), the single-column standard-field
// form (name row, email, mobile, organisation, marketing toggle, notes), and a
// right-aligned Save footer (no activity-log/created-on bars).

import { Bar, DEFAULT_LABEL, InputField, PageShell } from './primitives';

export function ContactEditSkeleton({ label = DEFAULT_LABEL }: { label?: string }) {
  return (
    <PageShell label={label}>
      <header className="flex-shrink-0 h-23 border-b border-dinnerplate-white">
        <div className="flex h-full w-full items-center px-6 sm:px-8 lg:px-16">
          <div className="flex items-center gap-2">
            <Bar className="h-5 w-[62px]" />
            <Bar className="size-3" />
            <Bar className="h-5 w-[88px]" />
            <Bar className="size-3" />
            <Bar className="h-5 w-[25px]" />
          </div>
        </div>
      </header>
      <div className="flex-1">
        <div className="w-full px-16 pt-8">
          <Bar className="h-[30px] w-40 mb-4" />
          <div className="flex flex-col gap-8">
            <div className="grid grid-cols-2 gap-6">
              <InputField />
              <InputField />
            </div>
            <InputField />
            <InputField />
            <InputField />
            <div className="flex items-center gap-4">
              <Bar className="h-5 w-56" />
              <Bar className="h-6 w-10 rounded-full" />
            </div>
            <div>
              <Bar className="h-[17px] w-[72px] mb-2" />
              <Bar className="h-20 w-full rounded-input" />
            </div>
          </div>
        </div>
      </div>
      <footer className="flex-shrink-0 h-23 border-t border-dinnerplate-white">
        <div className="flex h-full w-full items-center justify-end px-16">
          <Bar className="h-[45px] w-[131px] rounded-input" />
        </div>
      </footer>
    </PageShell>
  );
}
